// extracted by mini-css-extract-plugin
module.exports = {"holder":"recommendations_holder__1ZwTe","list":"recommendations_list__1eqCu","infoHolder":"recommendations_infoHolder__2L66l"};